import { AppStageState } from "../store/appStageReducer";

export async function getAppStage(): Promise<AppStageState> {
    return await fetch("/api/appstage/", {
        method: "GET",
    }).then(res => {
        return res.json();
    });
}
